module.exports = __webpack_public_path__ + "img/jhu_covid_19_generic.png";